module.exports = __webpack_public_path__ + "img/prod-3.eb175d20.png";